import { FormEvent, useState, useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import type { User } from '../api/types';

export default function PixPage() {
  const { user, refresh } = useAuth();
  const qc = useQueryClient();
  const navigate = useNavigate();

  const [pixKey, setPixKey] = useState('');
  const [feedback, setFeedback] = useState<{ kind: 'ok' | 'err'; text: string } | null>(null);

  useEffect(() => {
    setPixKey(user?.pix_key ?? '');
  }, [user?.pix_key]);

  const save = useMutation({
    mutationFn: async () => {
      const { data } = await api.patch<User>('/auth/me', { pix_key: pixKey.trim() || null });
      return data;
    },
    onSuccess: async (updated) => {
      refresh(updated);
      qc.invalidateQueries({ queryKey: ['admin-bets'] });
      setFeedback({ kind: 'ok', text: '✓ Chave Pix salva' });
      setTimeout(() => setFeedback(null), 2500);
    },
    onError: (err: any) => {
      setFeedback({
        kind: 'err',
        text: err.response?.data?.message || 'Erro ao salvar',
      });
    },
  });

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    save.mutate();
  }

  return (
    <div className="card max-w-md mx-auto space-y-4">
      <div>
        <h2 className="text-xl font-bold">Chave Pix para premiação</h2>
        <p className="text-sm text-slate-600 mt-1">
          Se você for premiado, vamos enviar o valor para essa chave. Pode ser CPF, email,
          telefone ou chave aleatória.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-sm mb-1">Chave Pix</label>
          <input
            className="input"
            placeholder="cpf, email, telefone ou chave aleatória"
            value={pixKey}
            onChange={(e) => setPixKey(e.target.value)}
            maxLength={120}
            autoFocus
          />
        </div>

        {feedback && (
          <div
            className={`text-sm rounded px-3 py-2 ${
              feedback.kind === 'ok' ? 'bg-brand-500/10 text-brand-600' : 'bg-red-100 text-red-700'
            }`}
          >
            {feedback.text}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-2">
          <button type="submit" className="btn btn-primary w-full" disabled={save.isPending}>
            {save.isPending ? 'Salvando…' : user?.pix_key ? 'Alterar' : 'Cadastrar'}
          </button>
          <button
            type="button"
            className="btn btn-secondary w-full"
            onClick={() => navigate('/')}
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
